import { publicAPI } from "@/shared/lib";
import type { ServiceResponse } from "@/shared/lib/axios";
import type { EmbeddablesUser } from "../models";

export const getUserValidation = async (userCode: string) => {
  const { data } = await publicAPI.get<ServiceResponse<EmbeddablesUser>>(
    `/embeddables-user/${userCode}`,
  );

  return data.data;
};
